var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { margin: "10px", height: "95%" } },
    [
      _c("w-card-title", [_vm._v("ZPL editor")]),
      _c(
        "w-card-content",
        { style: { height: "100%" } },
        [
          _c("w-textarea", {
            model: {
              value: _vm.layout.Zpl,
              callback: function ($$v) {
                _vm.$set(_vm.layout, "Zpl", $$v)
              },
              expression: "layout.Zpl",
            },
          }),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "6" } },
                [
                  _c("w-input", {
                    attrs: { label: "Host", fancy: "" },
                    model: {
                      value: _vm.layout.ZplSettings.Host,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.ZplSettings, "Host", $$v)
                      },
                      expression: "layout.ZplSettings.Host",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { sm: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { decimals: 0, label: "Port", fancy: "" },
                    model: {
                      value: _vm.layout.ZplSettings.Port,
                      callback: function ($$v) {
                        _vm.$set(_vm.layout.ZplSettings, "Port", $$v)
                      },
                      expression: "layout.ZplSettings.Port",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }